<template>
  <div class="home py-5">
        <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wine.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <!-- Avant le formulaire : le televersement a sa propre route et part
           immediatement, il ne depend pas de la validation du formulaire. Le
           placer en tete evite de laisser croire qu'il faut « enregistrer »
           pour que l'image soit prise en compte. -->
      <AveineBottleImage
        resource="wines"
        :id="wine.id"
        :APIbaseURL="APIbaseURL"
      />
      <AveineWineForm :APIbaseURL="APIbaseURL" :wine="wine" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineForm } from 'aveine-wine'
import AveineBottleImage from '@/components/AveineBottleImage.vue'
import { Wine } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      wine: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Update',
  components: {
    AveineWineForm,
    AveineBottleImage
  },
  async beforeCreate() {
    try {
      await Wine.api().get(`wines/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
        params: {
          include:
            'template.grapes-composes-wine-template.grape.grape-variety,' +
            'template.appellation,' +
            'template.region,' +
            'template.country,' +
            'template.domain.region.country,' +
            'grapes-composes-wine.grape.grape-variety,' +
            'wine-labels,' +
            'appellation',
        }
      });
      let wine = await Wine.query().whereId(this.$route.params.id).withAllRecursive().first();
      let template = wine.template;
      wine.designation = template.designation;
      wine.color = template.color;
      wine.domain = template.domain;
      wine.region = template.region;
      wine.country = template.country;
      this.wine = wine;
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
